import { computed } from 'vue'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'

interface ResponseUseExpedientStage {
  expedientStage: ReturnType<typeof store.getters[`${ModuleNamespaces.EXPEDIENTS}/getExpedientStageState`]>
}

export default function useStage(): ResponseUseExpedientStage {
  // GETTERS
  const expedientStage = computed(() => store.getters[`${ModuleNamespaces.EXPEDIENTS}/getExpedientStageState`])

  return {
    expedientStage
  }
}
